import { uploadSingleFile } from "../files";
import { authClient, API } from "../index";

// Get all noticias
export const getNoticias = () => {
  return authClient().get(`${API}/noticia?getDisabled=true`);
};

// Get noticia by id
export const getNoticiaById = (id) => {
  return authClient().get(`${API}/noticia/${id}`);
};

// Delete noticia
export const deleteNoticia = (id) => {
  return authClient().delete(`${API}/noticia/${id}`);
};

// Create noticia
export const postNoticia = async (noticia, image, imageGrid, file) => {
  // Solo subir archivos si son instancias de File
  if (image && image instanceof File) {
    const response = await uploadSingleFile(image, "noticias");
    noticia.imageURL = response?.data?.fileURL;
  }
  if (imageGrid && imageGrid instanceof File) {
    const response = await uploadSingleFile(imageGrid, "noticias");
    noticia.imageGridURL = response?.data?.fileURL;
  }
  if (file && file instanceof File) {
    const response = await uploadSingleFile(file, "noticias");
    noticia.fileURL = response?.data?.fileURL;
  }
  return authClient().post(`${API}/noticia`, noticia);
};

// duplicar
export const duplicarNoticia = async (id, noticia) => {
  return authClient().post(`${API}/noticia/${id}`, noticia);
};

// Update noticia
export const updateNoticia = async (id, noticia, image, imageGrid, file) => {
  // Solo subir archivos si son instancias de File
  if (image && image instanceof File) {
    const response = await uploadSingleFile(image, "noticias");
    noticia.imageURL = response?.data?.fileURL;
  }
  if (imageGrid && imageGrid instanceof File) {
    const response = await uploadSingleFile(imageGrid, "noticias");
    noticia.imageGridURL = response?.data?.fileURL;
  }
  if (file && file instanceof File) {
    const response = await uploadSingleFile(file, "noticias");
    noticia.fileURL = response?.data?.fileURL;
  }
  return authClient().put(`${API}/noticia/${id}`, noticia);
};

// Change status noticia
export const changeStatusNoticia = async (id, active) => {
  return authClient().put(`${API}/noticia/change-status/${id}`, { active });
};
